/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export enum IpcMessages {
  SET_ACCOUNT = 'SET_ACCOUNT',
  SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT',
  MULTIPLE_ACCOUNT_BUGS = 'MULTIPLE_ACCOUNT_BUGS',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  GET_PROFILE = 'GET_PROFILE',
  SET_PROFILE = 'SET_PROFILE',
  GET_ACCOUNT = 'GET_ACCOUNT',
  GET_UPDATES_AVAILABLE = 'GET_UPDATES_AVAILABLE',
  UPDATE_AVAILABLE = 'UPDATE_AVAILABLE',
  OPEN_STORE_LINK = 'OPEN_STORE_LINK',
  OPEN_DEV_TOOLS = 'OPEN_DEV_TOOLS',
  GET_IP_ADDRESS = 'GET_IP_ADDRESS',
  SET_IP_ADDRESS = 'SET_IP_ADDRESS',
  CLEAR_LOCAL_STORAGE = 'CLEAR_LOCAL_STORAGE',
  EXIT_APP = 'EXIT_APP',
  ASK_CAMERA_ACCESS = 'ASK_CAMERA_ACCESS',
  GET_WIFI_SSID = 'GET_WIFI_SSID',
  SET_WIFI_SSID = 'SET_WIFI_SSID',
}

// Add here the endpoints for MS Graph API services you would like to use.
export const GRAPH_CONFIG = {
  GRAPH_ME_ENDPT: 'https://graph.microsoft-ppe.com/v1.0/me',
};
